import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "react-credit-cards/es/styles-compiled.css";
import { ToastContainer } from 'react-toastify';

import LoadingSpinner from './service/loaders/LoadingSpinner';
import NavBar from 'components/NavBarLog/Navbar'; // 👈 importa tu Navbar
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';

const TermConditions = lazy(() => import('./page/TermConditions/TermConditions'));
const MyTicket = lazy(() => import('./page/MyTickets/MyTicket'));
const Login = lazy(() => import('./page/Login/Login'));
const Home = lazy(() => import('./page/Home/Home'));
const Register = lazy(() => import('./page/Register/Register'));
const ForgotPassword = lazy(() => import('./page/ForgotPassword/ForgotPassword'));
const EventDetail = lazy(() => import('./page/EventDetail/EventDetail'));
const Payment = lazy(() => import('./page/Payment/Payment'));
const Custom404 = lazy(() => import('./page/404/404'));
const Calendar = lazy(() => import('./page/Calendar/Calendar'));
const Announce = lazy(() => import('./page/Announce/Announce'));
const ProtectedRoute = lazy(() => import('./components/ProtectedRoute/ProtectedRoute'));
const Profile = lazy(() => import('./page/Profile/Profile'));
const Crear = lazy(() => import('./page/crear/Crear'));
const SalazonInfo = lazy(() => import('./page/webinformativa/SalazonInfo'));

interface Props {
  children?: React.ReactNode;
}

const Render = (props: Props) => (
  <Suspense fallback={<LoadingSpinner />}>
    {props.children}
  </Suspense>
);

const LayoutWithNavBar = () => {
  const location = useLocation();

  // rutas donde NO debe mostrarse el Navbar
  const hideNavbarOn = ["/term-conditions"];
  const shouldShowNavbar = !hideNavbarOn.includes(location.pathname);

  return (
    <>
      {shouldShowNavbar && <NavBar showButtons={true} />}
      <Suspense fallback={<LoadingSpinner />}>
        {/* La `key` reinicia la animación en cada cambio de ruta: sin esto la
            navegación es un corte seco entre pantallas */}
        <div key={location.pathname} className="animate-fadeIn">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="home" element={<Home />} />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="recovery" element={<ForgotPassword />} />
          <Route path="/crear" element={<Crear />} />
          <Route path="/event/eventDetail/:id" element={<EventDetail />} />
          <Route path="/event/:id/payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
          <Route path="/my-tickets" element={<ProtectedRoute><MyTicket /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/term-conditions" element={<TermConditions />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/salazon-info/:id" element={<SalazonInfo />} />
          <Route path="*" element={<Custom404 />} />
        </Routes>
        </div>
      </Suspense>
    </>
  );
};


const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <LayoutWithNavBar />
        <ToastContainer />
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default App;
